import React from 'react';
import { Container } from './styles';
import CertificationLoader from './CertificationLoader';

const CertificationSkeletonLoader: React.FC = () => {
  return (
    <Container data-pw={'certification'}>
      <CertificationLoader />
    </Container>
  );
};

export default CertificationSkeletonLoader;
